class ObPdpInformation extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.ob-pdp-info__tab')];
    this.panels = [...this.querySelectorAll('.ob-pdp-info__panel')];
    this.media = window.matchMedia('(max-width: 749px)');
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.media.addEventListener('change', () => this.reset(), { signal });
    this.tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      const next = this.media.matches && tab.getAttribute('aria-expanded') === 'true' ? -1 : index;
      this.select(next);
    }, { signal }));
    this.reset();
  }

  disconnectedCallback() { this.controller?.abort(); }

  reset() {
    const mobile = this.media.matches;
    this.querySelector('.ob-pdp-info__items').setAttribute('role', mobile ? 'group' : 'tablist');
    this.select(mobile ? -1 : 0);
  }

  select(selected) {
    const mobile = this.media.matches;
    this.tabs.forEach((tab, index) => {
      const active = index === selected;
      const panel = this.panels[index];
      tab.setAttribute('aria-expanded', String(active));
      tab.setAttribute('aria-selected', String(active));
      if (mobile) tab.removeAttribute('role');
      else tab.setAttribute('role', 'tab');
      panel.hidden = !active;
      if (mobile) panel.removeAttribute('role');
      else panel.setAttribute('role', 'tabpanel');
    });
  }
}

if (!customElements.get('ob-pdp-information')) customElements.define('ob-pdp-information', ObPdpInformation);
